import { useState } from "react";
import { useAuth0 } from "@auth0/auth0-react";

import { useRoles } from "./useRoles";
import { useEffect } from "react";
import { useSelector } from "react-redux";

export const useUserRole = () => {
	const { user } = useAuth0();
	const { roles } = useRoles(false);
	const { users } = useSelector((store) => store.portal.users);

	const [currentUserRole, setCurrentUserRole] = useState(null);
	const [isOwnerRole, setIsOwnerRole] = useState(false);
	const [isAdminRole, setIsAdminRole] = useState(false);

	useEffect(() => {
		if (roles && users && user) {
			const currentUser = users.find((u) => u.auth0_id === user.cxfUserId);
			const userRole = roles.find((r) => r.id === currentUser?.role_id);
			if (userRole?.name?.toLowerCase() === "owner") {
				setIsOwnerRole(true);
			}

			if (userRole?.name?.toLowerCase() === "admin") {
				setIsAdminRole(true);
			}

			setCurrentUserRole(userRole);
		}
	}, [roles, users, user]);

	return { currentUserRole, isOwnerRole, isAdminRole };
};
